import { Button, HStack, VStack } from '@bpba/ui-components';
import { FC } from 'react';
import { Spinner } from '../shared/Spinner';
import { EMAIL_LABEL, EMAIL_MAX_LENGTH, EMAIL_PLACEHOLDER } from '../../constants/form';
import { FormularioOtp } from '../shared/otp/FormularioOtp';
import { useLoginManager } from './useLoginManager';
import { ErrorMessageContainer } from '../shared/ErrorMessageContainer';
import { BPFormProvider, Input } from '@bpba/form-components';
import { LoginRules } from './LoginRules';
import { Titulo } from '../shared/Titulo';
import { FormLink } from '../shared/FormLink';
import { UrlsFront } from '../../constants/urls';

export const LoginComponent: FC = () => {
  const [isLoading, isRequestError, requestErrorMessage, emailBlocked, showEmail, showOTP, showConfirmButton, confirm, otp, setOtp, showErrorOtp, form] = useLoginManager();

  const confirmMessage = showOTP ? 'Confirmar' : 'Enviar';

  return (
    <>
      <Titulo>Ingresar</Titulo>
      {isLoading && <Spinner width={40} my={'48px'} />}
      <VStack display={showEmail ? 'flex' : 'none'} aria-hidden={emailBlocked}>
        <BPFormProvider methods={form} rules={LoginRules}>
          <Input name="email" control={form.control} placeholder={EMAIL_PLACEHOLDER} readOnly={emailBlocked} required={true} maxLength={EMAIL_MAX_LENGTH} label={EMAIL_LABEL} />
        </BPFormProvider>
      </VStack>

      {showOTP && <FormularioOtp otp={otp} setOtp={setOtp} ariaHidden={false} showError={showErrorOtp} />}

      <ErrorMessageContainer show={isRequestError} errorMessage={requestErrorMessage} />

      <HStack>
        <Button mt={'8px !important'} variant="secondary" display={showConfirmButton ? 'unset' : 'none'} onClick={confirm}>
          {confirmMessage}
        </Button>
      </HStack>

      <FormLink title={'Registro'} url={UrlsFront.SignUpHome} show={!isLoading} />
    </>
  );
};
